export default {
    maintenceMode: process.env.REACT_APP_MAINTENCE,
}